import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export interface SpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "default" | "primary" | "muted";
}

export const Spinner = ({ 
  className, 
  size = "md",
  variant = "default" 
}: SpinnerProps) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-12 w-12"
  };

  const variantClasses = {
    default: "text-primary",
    primary: "text-primary",
    muted: "text-muted-foreground"
  };

  return (
    <Loader2 
      className={cn(
        "animate-spin", 
        sizeClasses[size],
        variantClasses[variant],
        className
      )} 
    />
  );
};

// Componente de Loading Completo
export interface LoadingProps {
  text?: string;
  className?: string;
  variant?: "default" | "primary" | "muted";
}

export const Loading = ({ 
  text = "Cargando...", 
  className,
  variant = "default" 
}: LoadingProps) => {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center min-h-[200px] gap-3", 
      className
    )}>
      <Spinner size="lg" variant={variant} />
      {text && (
        <p className="text-sm text-muted-foreground">{text}</p>
      )}
    </div>
  );
};
















